/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { DynamodbTableRestoreDestination } from '../models/DynamodbTableRestoreDestination';

export class RestoreDynamoDBTableRequest {
  /**
  * Eon-assigned ID of the restore account.
  */
  'restoreAccountId': string;
  'destination': DynamodbTableRestoreDestination;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "restoreAccountId",
      "baseName": "restoreAccountId",
      "type": "string",
      "format": ""
    },
    {
      "name": "destination",
      "baseName": "destination",
      "type": "DynamodbTableRestoreDestination",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return RestoreDynamoDBTableRequest.attributeTypeMap;
  }

  public constructor() {
  }
}

